export const getLocale = (locale: string) => {
  const map = locale.split('_')
  return {
    language: map[0],
    country: map[1],
    domain: [
      'AE',
      'SG',
      'IN',
      'CA',
      'JP',
      'AU',
      'BE',
      'BR',
      'MX',
      'TR',
      'DE',
      'FR',
      'IT',
      'ES',
      'NL',
      'PL',
      'SA',
      'SE',
      'EG'
    ].includes(map[1].toUpperCase())
      ? `${['AU', 'BE', 'BR', 'MX', 'TR'].includes(map[1].toUpperCase()) ? 'com.' : ''}${
          ['JP'].includes(map[1].toUpperCase()) ? 'co.' : ''
        }${map[1]}`
      : 'GB' == map[1]
        ? 'co.uk'
        : 'com'
  }
}
